import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';

import { FilenamePipe } from '../../../../../../../pipes/filename.pipe';
import { FormPackage } from '../../models/df-package';
import { FontFamily } from '../../models/df-font-family';
import { FontFamilyService } from '../../services/df-font-family.service';
import { FontsService } from '../../../../../../../services/fonts.service';
@Component({
	selector: 'df-font-box',
	templateUrl: './font-box.component.html',
	styleUrls: ['./font-box.component.scss'],
	providers: [FontFamilyService]
})
export class FontBoxComponent implements OnInit {
	@Input() package: FormPackage;
	get inValid() {
		const fontGroup = this.config.get(this.package.key) as FormGroup;
		return fontGroup.get('size').invalid;
	}
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	text_sizeFocus = Boolean(false);
	fonts: Array<FontFamily>;

	constructor(private ffs: FontFamilyService) {
		this.fonts = ffs.getFonts();
	}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit() {}

	isEmpty() {
		const fontGroup = this.config.get(this.package.key) as FormGroup;
		return fontGroup.get('size').hasError('required');
	}

	isMin() {
		const fontGroup = this.config.get(this.package.key) as FormGroup;
		return fontGroup.get('size').hasError('min');
	}

	isMax() {
		const fontGroup = this.config.get(this.package.key) as FormGroup;
		return fontGroup.get('size').hasError('max');
	}
}
